<template>
  <v-text-field class="mt-1"
    ref="input"
    dense
    hide-details
    v-model.trim="internalValue"
    @focus="focused = true"
    @blur="focused = false"
    @change="apply()"
  >
    <template v-if="!focused" v-slot:append-outer>
      <v-icon
        class="pointer"
        :color="!clearIconHovered ? 'green' : 'red'"
        v-if="showClearIcon"
        @mouseenter="clearIconHovered = true"
        @mouseleave="clearIconHovered = false"
        @click="clear()"
      >mdi-filter-remove</v-icon>
    </template>
  </v-text-field>
</template>
<script>
import simpleFilterMixin from '@/components/data-table-filters/filters/simple-filter-mixin'
export default {
  name: 'FilterText',
  mixins: [simpleFilterMixin]
}
</script>
